import { CommonModule } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatNativeDateModule, MatOptionModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from "@angular/material/input";
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTable, MatTableModule } from '@angular/material/table';
import { Router } from "@angular/router";
import { CurrencyMaskDirective } from "src/app/shared/directive/currency-mask.directive";
import { provideNgxMask } from "ngx-mask";
import { SolicitacaoService } from "src/app/core/apis/solicitacao/solicitacao.service";
import { Titular } from "src/app/core/model/titular";
import { ErrorHandlerService } from "src/app/core/service/error-handler.service";
import { OrdemBuilderService } from "src/app/core/service/ordem-builder.service";
import { UserDataService } from "src/app/core/service/user-data.service";
import { AcaoButtonsComponent } from "src/app/shared/components/acao-buttons/acao-buttons.component";
import { ListaTitularesComponent } from "src/app/shared/components/lista-titulares/lista-titulares.component";
import { SlaSelectorComponent } from "src/app/shared/components/sla-selector/sla-selector.component";
import { NoSpecialCharsDirective } from "src/app/shared/directive/no-special-chars.directive";
import { Globals } from "src/app/shared/helpers/globals";
import { CustomValidators } from "src/app/shared/validators/custom-validators";

@Component({
    selector: "app-incluir-acao-form",
    templateUrl: "./incluir-acao-form.component.html",
    styleUrls: ["./incluir-acao-form.component.css"],
    providers: [provideNgxMask()],
    imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatRadioModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    MatMenuModule,
    MatIconModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCheckboxModule,
    CurrencyMaskDirective,
    NoSpecialCharsDirective,
    SlaSelectorComponent,
    AcaoButtonsComponent,
    ListaTitularesComponent
]
})
export class IncluirAcaoFormComponent implements OnInit {

  @Input() tokenIam: string;
  @Input() nroProcesso: string;

  form: UntypedFormGroup;
  titulares: Titular[];
  comarca: string;

  @ViewChild(MatTable) table: MatTable<Titular>;
  @ViewChild(ListaTitularesComponent) listaTitularesComponent!: ListaTitularesComponent;

  displayedColumns: string[] = ["nome", "documento", "action"];

  constructor(
    private router: Router,
    private globals: Globals,
    private solicitacaoService: SolicitacaoService,
    private userDataService: UserDataService,
    private ordemBuilderService: OrdemBuilderService,
    private errorHandler: ErrorHandlerService,
    public snackBar: MatSnackBar,
    fb: UntypedFormBuilder
  ) {
    this.form = fb.group({
      nroSla: ["120", Validators.required],
      vlrAcao: ["", [Validators.required, CustomValidators.validatorCurrencyZero]],
      autor: ["", [Validators.required, CustomValidators.validatorOnlyNumber]],
      reu: ["", [Validators.required, CustomValidators.validatorOnlyNumber]],
      cartaComunicado: [false]
    });
    this.titulares = [];
  }

  ngOnInit() {
    this.userDataService.userData.subscribe(userData =>{
      this.comarca = userData.comarca;
    });
  }

  public onTitularesChange(titulares: Titular[]) {
    this.titulares = titulares;
  }

  public incluirOrdem() {
    if(!this.isFormValid()){
      this.touchForm();
      return;
    };
    this.touchForm();
    this.globals.addToLoading("cadastrar-ordem");
    const ordem = this.ordemBuilderService.buildInclusao(this.nroProcesso, this.titulares, this.form.value);
    this.solicitacaoService.saveSolicitacao(ordem, this.tokenIam).subscribe({
      next: (response) => {
        this.globals.subtractFromLoading();
        this.globals.showSnackBar("Inclusão enviada com sucesso!", ["snackbar-success"]);
        this.router.navigate(["/ordem"]);
      },
      error: (error) => {
        this.globals.subtractFromLoading();
        this.errorHandler.handle(error);
      }
    });
  }

  touchForm() {
    this.form.markAllAsTouched();
    if(this.isTitularesEmpty()){
      this.listaTitularesComponent.nome.setErrors({titularesEmpty: true})
      this.listaTitularesComponent.documento.setErrors({titularesEmpty: true})
      this.listaTitularesComponent.form.markAllAsTouched();
    }
  }

  private isFormValid(): boolean{
    return this.form.valid && !this.isTitularesEmpty();
  }

  private isTitularesEmpty(): boolean{
    return this.titulares.length == 0;
  }

  get nroSla() {
    return this.form.get("nroSla");
  }

  get vlrAcao() {
    return this.form.get("vlrAcao");
  }

  get autor() {
    return this.form.get("autor");
  }

  get reu() {
    return this.form.get("reu");
  }

  get cartaComunicado() {
    return this.form.get("cartaComunicado");
  }

}
